/* Keep native form submission and line properties; count requested swatches. */
(() => {
  if (customElements.get('sample-quantity-sync')) return;
  const sampleIds = new Set([51331883434277, 52082153783589]);
  const guardCart = e => {
    const notice=document.querySelector('[data-sample-cart-invalid]');if(!notice)return;
    const checkout=e.type==='submit' ? e.submitter?.name==='checkout' : e.target.closest?.('button[name="checkout"],input[name="checkout"],a[href*="/checkout"],.additional-checkout-buttons');
    if(!checkout)return;
    e.preventDefault();e.stopImmediatePropagation();notice.scrollIntoView({block:'center'});notice.focus({preventScroll:true});
  };
  document.addEventListener('click',guardCart,true);
  document.addEventListener('submit',guardCart,true);

  class SampleQuantitySync extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const form = this.closest('form'); if (!form) return;
        const controls = () => Array.from(form.elements);
        const fields = () => controls().filter(e => /^(INPUT|TEXTAREA)$/.test(e.tagName) && /^properties\[[1-5][\s　]/.test(e.name || '') && e.type !== 'checkbox');
        const quantity = () => controls().find(e => e.name === 'quantity');
        const status = this.querySelector('[data-sample-count]');
        const error = this.querySelector('[data-sample-error]');
        let synchronizing = false, checking = false, approved = false;
        const count = () => fields().filter(e => e.value.trim()).length;
        const sync = () => {
          if (synchronizing) return;
          synchronizing = true;
          const n = count(), select = quantity();
          if (select) {
            const value = String(Math.max(1,n));
            if (select.value !== value) { select.value = value; select.dispatchEvent(new Event('change', {bubbles:true})); }
            const summary = select.closest('.qty-standard-summary');
            if (summary) {
              summary.querySelector('.qty-standard-select-shell')?.setAttribute('hidden','');
              summary.querySelector('.qty-standard-stepper')?.setAttribute('hidden','');
            }
          }
          fields().forEach(field => {
            field.setCustomValidity(field.required && !field.value.trim() ? '生地の品番とカラーをご記入ください。' : '');
            const label = Array.from(document.querySelectorAll('label')).find(e=>e.htmlFor===field.id);
            if(label && /数量[2-5]に変更/.test(label.textContent)) label.textContent=label.textContent.replace(/（数量[2-5]に変更ください）/,'');
          });
          status.textContent = n ? `サンプル${n}点分の購入数に自動で合わせています。` : '1欄に1色ずつご記入ください。入力した欄の数が購入数になります（合計5点まで）。';
          synchronizing = false;
        };
        const opts = {signal:this.abort.signal};
        document.addEventListener('input', e=>{if(e.target.form===form) {error.textContent='';sync();}},opts);
        document.addEventListener('change', e=>{if(e.target.form===form)sync();},opts);
        form.addEventListener('submit', async e => {
          if (approved) { approved=false; return; }
          e.preventDefault(); e.stopImmediatePropagation();
          if(checking)return;
          fields().forEach(field=>{field.value=field.value.trim();});
          sync(); if(!form.reportValidity())return;
          const n=count(); if(n<1||n>5) {error.textContent='サンプルは1〜5点でご指定ください。';return;}
          checking=true; error.textContent='カート内のサンプル数を確認しています。';
          const button=e.submitter;
          try {
            const response=await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
            if(!response.ok)throw Error('cart');
            const cart=await response.json();
            const existing=cart.items.reduce((sum,item)=>sum+(sampleIds.has(Number(item.variant_id))?Number(item.quantity):0),0);
            if(existing+n>5){error.textContent=`カートにサンプルが${existing}点あります。1回のご注文は合計5点までです。カートの内容か入力する色数を調整してください。`;return;}
            if(!form.isConnected)return;
            // Re-read in case the customer edited a field while the cart was loading.
            sync(); if(existing+count()>5||!form.reportValidity()) {error.textContent='入力内容を確認して、もう一度カートに入れてください。';return;}
            error.textContent='';approved=true;
            form.requestSubmit(button?.isConnected?button:undefined);
          } catch (_) {error.textContent='カートを確認できませんでした。通信状況をご確認のうえ、もう一度お試しください。';}
          finally {checking=false;approved=false;}
        }, {capture:true,signal:this.abort.signal});
        sync();
      });
    }
    disconnectedCallback(){this.abort?.abort();}
  }
  customElements.define('sample-quantity-sync',SampleQuantitySync);
})();
